import Axios from "@/plugins/Axios";

export class NovidadesService {
  async getPublicReleases(params = {}) {
    const response = await Axios().get("/novidades/public", { params });
    return response.data;
  }

  async syncReleases() {
    const response = await Axios().post("/novidades/sync");
    return response.data;
  }
}

export default new NovidadesService();
